module.exports = __webpack_public_path__ + "static/media/S2.caadba94.png";